import { render, staticRenderFns } from "./DynamicCohortBuilder.vue?vue&type=template&id=298947ee&scoped=true&"
import script from "./DynamicCohortBuilder.vue?vue&type=script&lang=js&"
export * from "./DynamicCohortBuilder.vue?vue&type=script&lang=js&"
import style0 from "./DynamicCohortBuilder.vue?vue&type=style&index=0&id=298947ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298947ee",
  null
  
)

export default component.exports